export default __webpack_public_path__ + "static/media/clever2.54130977.png";